import React from 'react';
import './InfoSections.css';

export default function InfoSections() {
  return (
    <div id="v3-strict-scope" className="info-sections-wrapper">

      {/* =========================================
          SECTION 1: WHY CHECK WITH DIGITMONEY?
          ========================================= */}
      <section id="why-us" className="why-us-section">
        <div className="section-container">
          <span className="section-label">WHY US</span>
          <h2 className="section-title">Why check with<br />DigitMoney?</h2>

          <div className="why-us-cards">
            <div className="why-card">
              <div className="bg-number">01</div>
              <div className="why-icon"><img src="/assets/img/Blocks-and-arrows.svg" alt="icon" /></div>
              <h3>More options</h3>
              <p>Explore gold-loan options from multiple lending partners.</p>
            </div>

            <div className="why-card">
              <div className="bg-number">02</div>
              <div className="why-icon"><img src="/assets/img/Ranking.svg" alt="icon" /></div>
              <h3>Find a suitable rate</h3>
              <p>Compare available options based on your requirement and eligibility.</p>
            </div>

            <div className="why-card">
              <div className="bg-number">03</div>
              <div className="why-icon"><img src="/assets/img/Cycle.svg" alt="icon" /></div>
              <h3>Simple process</h3>
              <p>Complete your application online and continue with the lender you choose.</p>
            </div>

            <div className="why-card">
              <div className="bg-number">04</div>
              <div className="why-icon"><img src="/assets/img/Gift.svg" alt="icon" /></div>
              <h3>Your gold stays yours</h3>
              <p>Your gold is pledged as security. You don't sell it.</p>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          SECTION 2: WHAT CAN YOU USE A GOLD LOAN FOR?
          ========================================= */}
      <section id="use-cases" className="use-cases-section">
        <div className="section-container">
          <span className="section-label text-light">USE CASES</span>
          <h2 className="section-title">
            What can you use<br />a <span className="text-white">Gold Loan</span> for?
          </h2>

          <div className="use-cases-grid">
            <div className="use-case-card">
              <div className="use-icon"><img src="/assets/img/Home.svg" alt="icon" /></div>
              <h3>Home expenses</h3>
              <p>Repairs, renovation or other household needs</p>
            </div>

            <div className="use-case-card">
              <div className="use-icon"><img src="/assets/img/Handbag.svg" alt="icon" /></div>
              <h3>Business needs</h3>
              <p>Working capital or business expansion</p>
            </div>

            <div className="use-case-card">
              <div className="use-icon"><img src="/assets/img/Book-open.svg" alt="icon" /></div>
              <h3>Education</h3>
              <p>Fees and education-related expenses</p>
            </div>

            <div className="use-case-card">
              <div className="use-icon"><img src="/assets/img/Medicine-bottle-one.svg" alt="icon" /></div>
              <h3>Medical needs</h3>
              <p>Unexpected medical expenses</p>
            </div>

            <div className="use-case-card">
              <div className="use-icon"><img src="/assets/img/Bank-card.svg" alt="icon" /></div>
              <h3>Existing dues</h3>
              <p>Manage urgent financial commitments</p>
            </div>

            <div className="use-case-card">
              <div className="use-icon"><img src="/assets/img/Windmill-two.svg" alt="icon" /></div>
              <h3>Personal needs</h3>
              <p>Whatever matters to you</p>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          SECTION 3: PROCESS TIMELINE (SVG IMAGE ONLY)
          ========================================= */}
      <section id="process" className="process-section">
        <div className="section-container">

          {/* DESKTOP SVG (Hidden on Mobile) */}
          <div className="process-desktop-svg">
            <img
              src="/assets/img/ProcessTimelineSVGDesktop.svg"
              alt="How to get a gold loan timeline"
              className="process-svg-img"
            />
          </div>

          {/* MOBILE SVG (Hidden on Desktop) */}
          <div className="process-mobile-svg">
            <img
              src="/assets/img/FullProcessTimeLineMobile.svg"
              alt="How to get a gold loan timeline"
              className="process-svg-img"
            />
          </div>

        </div>
      </section>

    </div>
  );
}